"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GroupsWindow;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIntl = require("react-intl");

var _GroupsWindowModule = _interopRequireDefault(require("./GroupsWindow.module.scss"));

var _WindowControls = _interopRequireDefault(require("../../WindowControls/WindowControls"));

var _Button = _interopRequireDefault(require("../../../inputElements/Button/Button"));

var _EButtonType = _interopRequireDefault(require("../../../inputElements/Button/EButtonType"));

var _TabContentGuild = _interopRequireDefault(require("./components/TabContentGuild/TabContentGuild"));

var _GroupsWindow = _interopRequireDefault(require("./GroupsWindow.i18n"));

var _TabContentNation = _interopRequireDefault(require("./components/TabContentNation/TabContentNation"));

var _TabContentFriends = _interopRequireDefault(require("./components/TabContentFriends/TabContentFriends"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function GroupsWindow(_ref) {
  var guild = _ref.guild,
      guildMemberType = _ref.guildMemberType,
      nation = _ref.nation,
      friends = _ref.friends,
      _ref$initialTab = _ref.initialTab,
      initialTab = _ref$initialTab === void 0 ? "GUILD" : _ref$initialTab,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var _useState = (0, _react.useState)(initialTab),
      _useState2 = _slicedToArray(_useState, 2),
      activeTab = _useState2[0],
      setActiveTab = _useState2[1];

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_GroupsWindowModule.default.window, guildMemberType && _GroupsWindowModule.default[guildMemberType], className),
    style: style
  }, /*#__PURE__*/_react.default.createElement(_WindowControls.default, {
    className: _GroupsWindowModule.default.windowControls,
    classNameDragHandler: _GroupsWindowModule.default.dragHandler,
    classNameCloseBtn: _GroupsWindowModule.default.closeBtn
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _GroupsWindowModule.default.tabs
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.CMD_TAB,
    onClick: function onClick() {
      return setActiveTab("GUILD");
    },
    isDisabled: activeTab === "GUILD",
    className: (0, _classnames.default)(_GroupsWindowModule.default.tab, _GroupsWindowModule.default.tab1)
  }, formatMessage(_GroupsWindow.default.guild)), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.CMD_TAB,
    isDisabled: activeTab === "NATION",
    className: (0, _classnames.default)(_GroupsWindowModule.default.tab, _GroupsWindowModule.default.tab2)
  }, formatMessage(_GroupsWindow.default.nation)), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.CMD_TAB,
    onClick: function onClick() {
      return setActiveTab("FRIENDS");
    },
    isDisabled: activeTab === "FRIENDS",
    className: (0, _classnames.default)(_GroupsWindowModule.default.tab, _GroupsWindowModule.default.tab3)
  }, formatMessage(_GroupsWindow.default.friends))), /*#__PURE__*/_react.default.createElement("div", {
    className: _GroupsWindowModule.default.content
  }, activeTab === "GUILD" && /*#__PURE__*/_react.default.createElement(_TabContentGuild.default, {
    guild: guild,
    guildMemberType: guildMemberType
  }), activeTab === "NATION" && /*#__PURE__*/_react.default.createElement(_TabContentNation.default, {
    nation: nation
  }), activeTab === "FRIENDS" && /*#__PURE__*/_react.default.createElement(_TabContentFriends.default, {
    friends: friends
  })));
}